module.exports = __webpack_public_path__ + "files/SPIADI2026 - Annexe Réa Definition et diagnostic COL ILC BLC et SEPSIS.737afe9ecec561877f17e317de9b85fa.pdf";